import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 19 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 4.50009C14 6.98547 11.9853 9.00018 9.5 9.00018C7.01467 9.00018 5 6.98547 5 4.50009C5 2.01471 7.01467 0 9.5 0C11.9853 0 14 2.01471 14 4.50009ZM12.9819 4.50009C12.9819 2.57701 11.423 1.01812 9.5 1.01812C7.57695 1.01812 6.0181 2.57701 6.0181 4.50009C6.0181 6.42317 7.57695 7.98206 9.5 7.98206C11.423 7.98206 12.9819 6.42317 12.9819 4.50009ZM9.49949 11.018C4.81599 11.018 1.01926 14.8113 1.01926 19.4909C1.01926 19.7721 0.79109 20 0.509629 20C0.228169 20 0 19.7721 0 19.4909C0 14.249 4.25306 9.9998 9.49949 9.9998C14.7461 9.9998 19 14.2491 19 19.4909C19 19.7721 18.7718 20 18.4904 20C18.2089 20 17.9807 19.7721 17.9807 19.4909C17.9807 14.8115 14.1832 11.018 9.49949 11.018Z"
      />
    </svg>
  );
}
